import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export type SpinnerMode = 'absolute' | 'fixed';

@Component({
    selector: 'se-spinner',
    templateUrl: './se-spinner.component.html',
    styleUrls: ['./se-spinner.component.scss']
})
export class SeSpinnerComponent {

    constructor(translate: TranslateService) {
        this.title = translate.instant('Loading');
    }

    @Input()
    isBusy = false;

    @Input()
    mode: SpinnerMode = 'absolute';

    @Input()
    title: string;

    @Input()
    zIndex = 'initial';

    @Input()
    flexDirection = 'column';
}
